module.exports = __webpack_public_path__ + "static/img/WMP669_A.3e2e0f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WMP669_A.jpg
// module id = pghn
// module chunks = 0